import MIT from "../images/institutions/logo/MIT.png";
import berkley_logo from "../images/institutions/logo/berkley_logo.png";
import boston_logo from "../images/institutions/logo/boston_logo.png";
import harward_logo from "../images/institutions/logo/harward_logo.png";

export const SchoolMemberData = [
  {
    id: 7,
    institution: "Massachusetts Institute of Technology",
    logo: MIT,
    path: "/Mit",
  },
  {
    id: 8,
    institution: "Berkley University",
    logo: berkley_logo,
    path: "/Berkley",
  },
  {
    id: 9,
    institution: "Boston University",
    logo: boston_logo,
    path: "/Boston",
  },
  {
    id: 10,
    institution: "Harward University",
    logo: harward_logo,
    path: "/Harward",
  },
];
